import React from 'react';

import useOrganisationSettings from 'components/hooks/useOrganisationSettings';

import { OKR_TYPES } from 'constants/ProjectConstants';
import { StringModifier, modifyString } from 'constants/copyHelpers';

import { ConfirmationModal } from 'uiToolkitV1/ConfirmationModal';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

export const ChangeTimelineRealignModal = ({
  isOpen,
  onClose,
  handleNotRealignChildrenOKRs,
  handleRealignChildrenOKRs,
  okrType,
}) => (
  <ConfirmationModal
    isOpen={isOpen}
    onClose={onClose}
    isCentered
    title="Change Timeline"
    body={<ModalBody okrType={okrType} />}
    /* when user chooses to not re-align children i.e. No, he means he wants to re-align children to different timeline */
    cancelText="No"
    onCancel={handleRealignChildrenOKRs}
    /* when user chooses to re-align children i.e. Yes, he means he wants to keep hierarchy as currently shown */
    continueText="Yes"
    onContinue={handleNotRealignChildrenOKRs}
  />
);

const ModalBody = ({ okrType }) => {
  const { moduleName, objectivesName, keyResultsName } = useOrganisationSettings();

  const isObjective = okrType === OKR_TYPES.OBJECTIVE;

  return (
    <TextBodyMedium>
      When modifying the timeline of this{' '}
      {isObjective
        ? modifyString(objectivesName, StringModifier.SENTENCE_CASE)
        : modifyString(keyResultsName, StringModifier.SENTENCE_CASE)}
      , would you like to automatically realign all its child{' '}
      {modifyString(moduleName, StringModifier.PLURAL_SENTENCE_CASE)} to the updated timeline?
    </TextBodyMedium>
  );
};
